export default "__VITE_ASSET__CzAcZXHW__"